import { createApp } from 'vue';
import App from './App';
import i18n from './i18n';

(async () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const app = createApp(App);
  app.provide('i18n', (await i18n.common(params.locale)).default);
  app.mount('#app');
})();
